module.exports = __webpack_public_path__ + "media/icons/plus-1e51d813.png";